<!--
  편집 정보 템플릿 컴포넌트

  @since 2018-08-22
  @author kdydesign.kim
-->

<template>
  <div>
    <div v-if="group"
         class="contents-clearfix"></div>

    <div class="portlet edit-day-group">
      <table class="bs-table table-bordered-none">
        <colgroup>
          <col v-for="col in cols"
               :width="col"/>
        </colgroup>
        <tbody>
        <tr>
          <td class="td-head"
              style="padding-top:0px;max-width:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">
            {{$t('cmn.cfgAdm')}}
            <span style="margin-left:20px;color:black;">{{admin}}</span>
            <tool-tip>
              <div>{{admin}}</div>
            </tool-tip>
          </td>
          <td v-if="createDate !== void 0"
              class="td-head"
              style="padding-top:0px">{{$t('cmn.cfgCreateDt')}}
            <span style="margin-left:20px;color:black;">{{createDate}}</span>
          </td>
          <td class="td-head"
              style="padding-top:0px">{{$t('cmn.cfgDt')}}
            <span style="margin-left:20px;color:black;">{{date}}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EditPopupPanel',
    props: {
      admin: {
        type: String,
        default: void 0
      },
      date: {
        type: String,
        default: void 0
      },
      createDate: {
        type: String,
        default: void 0
      },
      group: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      cols () {
        if (this.createDate === void 0) {
          return ['55%', '45%']
        } else {
          return ['35%', '35%', '35%']
        }
      }
    }
  }
</script>
